export { Menu2 as default } from './Menu2';
